import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";
import ReactFancyBox from "react-fancybox";
const Item = ({
  item,

  moduleConfig,

  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.price) {
      items.push({
        text: "Price",
        value: `${item.price} ${getCurrencyCode()}`,
        type: "text",
      });
    }

    if (item.salePrice) {
      items.push({
        text: "Sale Price",
        value: `${item.salePrice} ${getCurrencyCode()}`,
        type: "text",
      });
    }

    if (item.imagesCount) {
      items.push({
        text: "Images Count",
        value: item.imagesCount,
        type: "number",
      });
    }

    return items;
  };

  return (
    <Card className="item mb-2 borderCream">
      {(item.status === "0" || item.status === 0) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.2)",
            width: "100%",
            height: "100%",
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            backdropFilter: "blur(1px)",
            borderRadius: "inherit",
          }}
        ></div>
      )}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0" style={{maxWidth:"60%"}}>
          <div className="d-flex ImageSectionSpacing">
            <div className="checkboxCol me-2 "></div>

            <div className="ms-1 me-2 position-relative fossilImage">
              <ReactFancyBox
                thumbnail={
                  process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                }
                image={
                  process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                }
                caption={`${item.title}`}
              />
            </div>
            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red text-md" >
                {item.title}
              </span>

              <span className="text-custom-4 mt-1 small  text-bold  text-info mt-1">
                {item.brand}
              </span>
            </div>
            <div className="position-relative d-inline-block mt-2 ms-3">
              {item.salePrice && (
                <h4 className="my-0 text-bold text-primaryCream text-lg" style={{whiteSpace:"nowrap"}}>
                  {item.salePrice} {getCurrencyCode()}
                </h4>
              )}

              {item.price && item.salePrice && (
                <span
                  className="position-absolute text-muted text-decoration-line-through"
                  style={{
                    top: "-10px",
                    right: "-40px",
                    fontSize: "0.8rem",
                  }}
                >
                  {item.price} {getCurrencyCode()}
                </span>
              )}

              {!item.salePrice && item.price && (
                <h4 className="my-0 text-bold text-primaryCream ">
                  {item.price} {getCurrencyCode()}
                </h4>
              )}
            </div>
          </div>
        </Card.Title>

        <div
          className="card-tools endColumn mb-1 pt-1"
          style={{ zIndex: 101, position: "relative" }}
        >
          <div>
            {item.showOnHomePage === "1" && (
              <span className="badge badge-pill badge-custom-3 me-1 text-white">
                In Home Page
              </span>
            )}
            {item.inStock === "1" && (
              <span className="badge badge-pill badge-custom-7 me-1 text-white">
                In Stock
              </span>
            )}
            {item.inStock === "0" && (
              <span className="badge badge-pill  badge-custom-6 me-1 text-dark">
                Out of Stock
              </span>
            )}
            <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span className="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>
            {item.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>

            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      {/* <Card.Body className="px-1 py-0">
        <Row>
          <Col className="mt-1 mb-1 ">
            <Row>
              <Col md={12} className="mt-1 mb-1">
                <StatsListing items={getItems()} />
              </Col>
            </Row>
            {item.shortDescription && (
              <>
                <Alert variant="light mb-0 pb-1 mb-2 px-2 pt-0 messageWidth">
                  <span className=" m-0 text-bold text-dark px-0 font-small ">
                    Short Description:{" "}
                    <span className="font-small text-normal ms-0 me-1 px-1 text-dark mb-0">
                      {item.shortDescription}
                    </span>
                  </span>
                </Alert>
              </>
            )}
          </Col>
        </Row>
      </Card.Body> */}
    </Card>
  );
};

export default Item;
